import classes from './Blogpost.module.css';

function Blogpost(props) {
    return (
        <li className={classes.item}>
            <div>
                {/*FIXME: it can't find the image*/}
                {/*<img src={props.image} alt={props.title}/>*/}
                {/*<img src={image} />*/}
            </div>
            <date className={classes.date}>{props.date}</date>
            <h5 className={classes.author}>{props.author}</h5>
            <h3 className={classes.title}>{props.title}</h3>
            <p className={classes.intro}>{props.intro}</p>
            <p className={classes.content}>{props.article}</p>
        </li>
    );
}

export default Blogpost;